// extracted by mini-css-extract-plugin
export default {"main":"styles_main__XPSD4","box":"styles_box__zuS00"};